export class Untersuchungsgruppe {
    untersuchungsgruppe_id: number;
    bezeichnung: string;
    erstellt: Date;
    editiert: Date;
}
